<template>
   <div class="pageFiles">
      <!-- MODAL CARGA DOCUMENTOS -->
      <b-modal
         size="lg"
         id="bv-modal-load"
         hide-footer
         :title="'Cargar Documentación Acuerdo ' + tempIdZOho"
         >
         <div v-if="loadListFiles" class="modalFiles">
            <div v-if="alertnofile" class="alert alert-danger">
               Se ha generado un problema con el documento cargado.
            </div>
            <div v-if="alertfile" class="alert alert-success">
               Proceso realizado correctamente.
            </div>
            <div class="alert alert-primary">
               Recuerde que después de cargar los documentos debe seleccionar
               <strong>Enviar Documentación</strong>.
            </div>
            <ValidationObserver ref="obsFieldsFiles">
               <FormUserFile
                  :FieldsForm="FormUserFile"
                  :method="executeFiles"
                  />
            </ValidationObserver>
            <div class="filesFooter">
               <button
                  v-if="viewloadfile"
                  class="btn btn-primary"
                  @click="loadfiles"
                  >
               Cargar Documentos
               </button>
            </div>
         </div>
      </b-modal>
      <!-- BUSQUEDA USUARIO -->
      <div v-if="viewBuqueda" class="searchContainer">
         <div class="searchInfo">
            <FormDataInscription />
         </div>
         <div class="searchForm">
            <ValidationObserver ref="obsFields">
               <FormUserInscription
                  :FieldsForm="FormUserInscription"
                  :ModelForm="formUserInsModel"
                  :method="executeProcess"
                  />
            </ValidationObserver>
            <div
               v-if="alertUser"
               class="alert alert-danger"
               >
               Los datos ingresados no se encuentran en nuestro sistema.
            </div>
         </div>
      </div>
      <!-- DATOS USUARIO -->
      <div v-if="!viewBuqueda" class="userInfoCard">
         <div class="userGrid">
            <div>
               <strong>Nombre:</strong>
               {{dataUser.NamPerson}} {{dataUser.LastNamePerson}}
            </div>
            <div>
               <strong>Teléfono:</strong>
               {{dataUser.DesContactInformationMobile}}
            </div>
            <div>
               <strong>Correo:</strong>
               {{dataUser.DesContactInformationEmail}}
            </div>
         </div>
      </div>
      <!-- TABLA DOCUMENTOS -->
      <div v-if="!viewBuqueda" class="documentsContainer">
         <div v-if="alertnofileSend" class="alert alert-danger">
            Error al enviar los archivos.
         </div>
         <div v-html="$store.state.txtActas"></div>
         <div class="linksActas">
            <div
               v-for="item in $store.state.liksActas"
               :key="item.id"
               >
               <a :href="item.linkActa" target="_blank">
               <img
                  width="30"
                  height="30"
                  src="@/assets/images/DocPDF.png"
                  />
               {{item.name}}
               </a>
            </div>
         </div>
         <!-- LEYENDA ICONOS -->
         <div class="legendIcons">
            <div>
               <img src="@/assets/images/DocView.png" width="30"/>
               Cargar Documentación
            </div>
            <div>
               <img src="@/assets/images/DocSend.png" width="30"/>
               Enviar Documentación
            </div>
            <div>
               <img src="@/assets/images/DocYes.png" width="30"/>
               Documentación Enviada
            </div>
            <div>
               <img src="@/assets/images/DocNot.png" width="30"/>
               Documentación Sin Enviar
            </div>
         </div>
         <!-- TABLA -->
         <b-table
            striped
            hover
            :items="dataUser.DetailPerson"
            :fields="VendorLabel"
            >
            <template v-slot:cell(deal)="row">
               <div :id="row.item.IdSignUpPersonDetail">
                  {{JSON.parse(JSON.parse(row.item.Detail_Zoho).details.output).updateDeal.id}}
               </div>
            </template>
            <template v-slot:cell(LevelProgram)="row">
               <div class="levelText">
                  {{row.item.NameLevel}}
               </div>
               <div class="programText">
                  {{row.item.NameProgram}}
               </div>
            </template>
            <template v-slot:cell(cargar)="row">
               <div class="text-center">
                  <img
                     v-if="row.item.Send_Files !== 2"
                     src="@/assets/images/DocView.png"
                     width="30"
                     @click="viewloadFile(row.item)"
                     />
                  <img
                     v-if="row.item.Send_Files === 1"
                     src="@/assets/images/DocSend.png"
                     width="30"
                     @click="sendZohoFiles(row.item)"
                     />
                  <img
                     v-else-if="row.item.Send_Files === 2"
                     src="@/assets/images/DocYes.png"
                     width="30"
                     />
                  <img
                     v-else
                     src="@/assets/images/DocNot.png"
                     width="30"
                     @click="viewloadFile(row.item)"
                     />
               </div>
            </template>
         </b-table>
         <div class="alert alert-primary">
            Recuerde enviar la documentación una vez cargados los archivos.
         </div>
      </div>
   </div>
</template>
<script>
import FormDataInscription from '@/components/Inscriptions/FormInscriptionFile.vue'
import FormUserInscription from '@/components/Forms.vue'
import FormUserFile from '@/components/Forms.vue'
import IberoHelpers from '@/store/helpers.js'

export default {
  name: 'InscFiles',
  data () {
    return {
      VendorLabel: [
        {
          key: 'IdSignUpPersonDetail',
          label: 'ID',
          sortable: false,
        },
        {
          key: 'deal',
          label: 'Acuerdo',
          sortable: false,
        },
        {
          key: 'CreateDate',
          label: 'Creación',
          sortable: false,
        },
        {
          key: 'LevelProgram',
          label: 'Nivel de Estudio / Programa',
          sortable: false,
        },
        {
          key: 'cargar',
          label: 'Documentos',
          sortable: false,
        },
      ],
      msnFilesAlert: '',
      tempIdZOho: '',
      listDocuments: [],
      alertUser: false,
      alertnofile: false,
      alertnofileSend: false,
      alertfile: false,
      loadListFiles: false,
      viewBuqueda: true,
      viewloadfile: false,
      dataUser: {},
      formUserInsModel: {
        IdDocType: '',
        IdDocument: '',
        IdCelPhone: '',
        IdMail: '',
      },
      formUserFileModel: [],
      arrayUserFileModel: [],
      arrayUserFileUser: [],
      FormUserInscription: [
        {
          id: 'IdDocType',
          model: 'IdDocType',
          name: 'Tipo de Documento',
          type: 'Select',
          placeholder: 'Tipo de Documento',
          values: this.$store.state.DocTypesList,
          validate: {
            required: true,
          },
          class: 'col-md-12',
        },
        {
          id: 'IdDocument',
          model: 'IdDocument',
          name: 'Documento de Identidad',
          type: 'input',
          placeholder: 'Documento de Identidad',
          values: '',
          validate: {
            required: true,
            min: 7,
            max: 10,
          },
          class: 'col-md-12',
        },
        {
          id: 'IdCelPhone',
          model: 'IdCelPhone',
          name: 'Teléfono Celular',
          type: 'input',
          placeholder: 'Teléfono Celular',
          values: '',
          validate: {
            required: true,
            numeric: true,
            max: 10,
            min: 10,
          },
          class: 'col-md-12',
        },
        {
          id: 'IdMail',
          model: 'IdMail',
          name: 'Correo Electrónico',
          type: 'input',
          placeholder: 'Correo Electrónico',
          values: '',
          validate: {
            required: true,
            email: true,
          },
          class: 'col-md-12',
        },
        {
          id: 'Sch_User',
          type: 'button',
          placeholder: 'Consultar',
          class: 'col-md-12',
        },
      ],
      FormUserFile: [],
    }
  },
  components: {
    FormDataInscription,
    FormUserInscription,
    FormUserFile,
  },
  methods: {
    loadfiles: function () {
      debugger
      this.alertfile = false
      this.alertnofileSend = false
      this.alertnofile = false
      return new Promise((resolve, reject) => {
        this.$refs.obsFieldsFiles.validate().then(results => {
          debugger
          if (!results) {
            IberoHelpers.scrollToTop(0, 300)
            resolve(false)
          } else {
            let loader = this.$loading.show({ zIndex: 9999 })
            this.arrayUserFileUser.length = 0
            if (this.formUserFileModel.length >= 1) {
              debugger
              var dataFile = IberoHelpers.sendUpdloadFileWithName(this.$store, this.formUserFileModel, 'INSCRIPTION', 0)
              debugger
              dataFile.then(Response => {
                if (!(Response === false)) {
                  for (var i = 0; i < Response.length; i++) {
                    debugger
                    let valueRef = JSON.parse(Response[i].wsDocument.data.id_File)
                    this.arrayUserFileUser.push({
                      Id_DetailPerson: Response[i].idUserSign,
                      Id_DocumentDegree: Response[i].idDocument,
                      Id_DocumentFile: valueRef[0].Id_File,
                    })
                  }
                  debugger
                  var resulEnd = IberoHelpers.sendFilesByPerson(this.$store, this.arrayUserFileUser)
                  resulEnd.then(Response => {
                    if (Response.data.status === '200') {
                      this.reloadPage(this.arrayUserFileUser[0].Id_DetailPerson)
                      this.alertfile = true
                      resolve(true)
                    } else {
                      this.alertnofile = true
                      resolve(false)
                    }
                    loader.hide()
                  })
                } else {
                  this.alertnofile = true
                  loader.hide()
                  resolve(false)
                }
              })
            } else {
              loader.hide()
              resolve(false)
            }
          }
        })
      })
    },
    reloadPage: function (referen) {
      let loader = this.$loading.show({ zIndex: 9999 })
      debugger
      var totalinf = IberoHelpers.getUserInscription(this.$store, this.formUserInsModel)
      totalinf.then(
        Response => {
          debugger
          if (Response.data[0] === undefined) {
            this.alertUser = true
            loader.hide()
            return false
          } else {
            this.dataUser = Response.data[0]
            this.viewBuqueda = false
            var listData = this.dataUser.DetailPerson.find(function (element) {
              return element.IdSignUpPersonDetail == referen
            })
            this.viewloadFile(listData)
            this.alertfile = true
            loader.hide()
            return true
          }
        }
      )
    },
    viewloadFile: function (data) {
      debugger
      this.tempIdZOho = JSON.parse(JSON.parse(data.Detail_Zoho).details.output).updateDeal.id
      var numproc = 0
      this.alertfile = false
      this.alertnofileSend = false
      this.alertnofile = false
      this.loadListFiles = false
      this.viewloadfile = false
      this.listDocuments.length = 0
      this.FormUserFile.length = 0
      this.formUserFileModel.length = 0
      debugger
      this.listDocuments = this.$store.state.DegreeDocumentList.find(function (element) {
        return element.IdDegree === data.IdLevel
      })

      for (var i = 0; i < this.listDocuments.DocDegree.length; i++) {
        let valorum = {}
        let addReference = false
        let dataIdDoc = this.listDocuments.DocDegree[i].IdDocument
        let dataDetail = this.listDocuments.DocDegree[i].Det_Detail

        if (dataDetail === '') {
          addReference = true
        } else if (dataDetail === 'HOM' && data.ReqHomologation === 'true') {
          addReference = true
        } else if (dataDetail === 'MAE' && data.IsMastery === true) {
          addReference = true
        } else if (dataDetail === 'EXT' && data.CodNationality != '169') {
          addReference = true
        }

        if (addReference === true) {
          if (!(data.FileDetail === undefined)) {
            valorum = data.FileDetail.find(function (element) {
              return element.IdDocType === dataIdDoc
            })
          }
          if ((!(valorum === undefined)) && Object.keys(valorum).length > 0) {
            this.FormUserFile.push(
              {
                id: 'detFileDoc_' + numproc + '_' + dataIdDoc + '_' + data.IdSignUpPersonDetail,
                name: this.listDocuments.DocDegree[i].NamDocument,
                type: 'file_detail',
                dataFile: JSON.parse(valorum.DetFile),
                DetURI: valorum.DetURI + valorum.NamFile,
                idFile: valorum.IdFile,
                IdDocument: valorum.IdDocument,
                class: 'col-md-12',
                delete: valorum.DetZoho === undefined,
              })
          } else {
            this.FormUserFile.push(
              {
                id: 'IdFileDoc_' + numproc + '_' + dataIdDoc + '_' + data.IdSignUpPersonDetail,
                name: this.listDocuments.DocDegree[i].NamDocument,
                type: 'file',
                validate: { required: this.listDocuments.DocDegree[i].StaRequired },
                class: 'col-md-12',
              })
            this.viewloadfile = true
          }
          numproc++
        }
      }
      this.loadListFiles = true
      this.$root.$emit('bv::show::modal', 'bv-modal-load', '#btnShow')
    },
    processUser: function () {
      let loader = this.$loading.show()
      debugger
      var totalinf = IberoHelpers.getUserInscription(this.$store, this.formUserInsModel)
      totalinf.then(
        Response => {
          debugger
          if (Response.data[0] === undefined) {
            this.alertUser = true
            loader.hide()
            return false
          } else {
            this.dataUser = Response.data[0]
            this.viewBuqueda = false
            loader.hide()
            return true
          }
        }
      )
    },
    sendZohoFiles: function (datRef) {
      this.alertnofileSend = false
      let message = {
        title: 'Enviar Documentos',
        body: '¿ Se realizará el envio de documentos a uno de nuestros asesores una vez realizado este proceso no podra volver a modificar los documentos cargados, está seguro de realizar este proceso ?',
      }
      let options = {
        okText: 'Continuar',
        cancelText: 'Cerrar',
      }
      debugger
      this.$dialog.confirm(message, options).then(dialog => {
        let loader = this.$loading.show({ zIndex: 9999 })
        let refeFile = []
        for (var i = 0; i < datRef.FileDetail.length; i++) {
          if (datRef.FileDetail[i].DetZoho === undefined) {
            refeFile.push({ IdFile: datRef.FileDetail[i].IdDocument, URIFile: datRef.FileDetail[i].DetURI + datRef.FileDetail[i].NamFile })
          }
        }
        var FileZoho = {
          IdSignUpZoho: this.tempIdZOho,
          FileDetail: refeFile,
        }
        debugger
        var resulEnd = IberoHelpers.sendFilesByPersonZoho(this.$store, FileZoho, datRef.IdSignUpPersonDetail)
        resulEnd.then(Response => {
          if (!(Response === false)) {
            if (Response.data.status === '200') {
              this.reloadPage(datRef.IdSignUpPersonDetail)
              this.alertfile = true
            } else {
              this.alertnofileSend = true
            }
          } else {
            this.alertnofileSend = true
          }
          loader.hide()
        })
      })
    },
    searchUser: function () {
      debugger
      this.alertUser = false
      return new Promise((resolve, reject) => {
        this.$refs.obsFields.validate().then(results => {
          debugger
          if (!results) {
            IberoHelpers.scrollToTop(0, 300)
            resolve(false)
          } else {
            resolve(this.processUser())
            debugger
          }
        })
      })
    },
    reValidate: function (event, id) {
      document.getElementById(this.FormUserFile[id].id).classList.remove('is-valid')
      document.getElementById(this.FormUserFile[id].id).classList.remove('is-invalid')
      document.getElementById('error_' + this.FormUserFile[id].id).innerHTML = ''

      if (event.size >= this.$store.state.filesIbero.sizeFiles) {
        document.getElementById(this.FormUserFile[id].id).classList.add('is-invalid')
        document.getElementById('error_' + this.FormUserFile[id].id).innerHTML = 'El tamaño del archivo cargado excede el límite permitido de ' + IberoHelpers.formatBytes(this.$store.state.filesIbero.sizeFiles, 0)
        this.FormUserFile[id].validate.required = true
        return false
      } else if (RegExp('\.(' + this.$store.state.filesIbero.extFiles + ')$', 'i').test(event.name) === false) {
        document.getElementById(this.FormUserFile[id].id).classList.add('is-invalid')
        document.getElementById('error_' + this.FormUserFile[id].id).innerHTML = 'El formato del archivo cargado no es valido, los formatos validos son: (' + this.$store.state.filesIbero.extFiles.replace(/[|]/g, ', ') + ')'
        this.FormUserFile[id].validate.required = true
      } else {
        if (event === undefined) {
          this.FormUserFile[id].validate.required = true
        } else {
          this.FormUserFile[id].validate.required = false
        }
      }
      this.$refs.obsFieldsFiles.validate()
      return event
    },
    executeFiles: function (event, ref) {
      if (event.type === 'file_detail') {
        if (ref === 'Delete') {
          var message = {
            title: 'Eliminar documento',
            body: '¿ Se realizará la eliminacion del documento "' + event.dataFile.Nam_File + '", está seguro de realizar este proceso ?',
          }
        } else {
          var message = {
            title: 'Enviar archivo',
            body: '¿ Se realizará el envio del documento "' + event.dataFile.Nam_File + '" a uno de nuestros asesores una vez realizado este proceso no podra volver a modificarlo, está seguro de realizar este proceso ?',
          }
        }

        let options = {
          okText: 'Continuar',
          cancelText: 'Cerrar',
        }

        this.$dialog.confirm(message, options).then(dialog => {
          let loader = this.$loading.show({ zIndex: 9999 })
          var dataSubmit = event.id.split('_')

          if (ref === 'Delete') {
            var FileDelete = {
              Id_Document: event.IdDocument,
              Id_DetailPerson: dataSubmit[3],
              Id_DocumentDegree: dataSubmit[2],
              Id_DocumentFile: event.idFile,
            }

            var resulEnd = IberoHelpers.deleteFilesByPerson(this.$store, FileDelete, event.DetURI)
          } else {
            let refeFile = []
            refeFile.push({ IdFile: event.IdDocument, URIFile: event.DetURI })
            var FileZoho = {
              IdSignUpZoho: this.tempIdZOho,
              FileDetail: refeFile,
            }
            debugger
            var resulEnd = IberoHelpers.sendFilesByPersonZoho(this.$store, FileZoho, dataSubmit[3])
          }
          resulEnd.then(Response => {
            if (Response.data.status === '200') {
              this.reloadPage(dataSubmit[3])
              this.alertfile = true
              this.alertnofile = false
            } else {
              this.alertnofile = true
              this.alertfile = false
            }
            loader.hide()
          })
        })
      } else {
        if (event.target.files.length >= 1) {
          var dataSubmit = event.target.id.split('_')
          var dataFile = this.reValidate(event.target.files[0], dataSubmit[1])
          if (dataFile !== false) {
            event.target.nextElementSibling.innerText = event.target.files[0].name

            var listData = this.formUserFileModel.findIndex(function (element) {
              return element.idFileModule == dataSubmit[2]
            })

            if (listData >= 0) {
              this.formUserFileModel[listData].filedata = dataFile
            } else {
              this.formUserFileModel.push({ idFileModule: dataSubmit[2], idDetailUser: dataSubmit[3], filedata: dataFile })
            }
          }
        }
      }
      return true
    },
    executeProcess: function (event) {
      debugger
      switch (event.target.id) {
        case 'btn_Sch_User':
          this.searchUser()
          break
          return true
      }
    },
  },
  created () {
    debugger
    this.formUserInsModel.IdDocType = this.$route.params.docType === undefined ? '' : this.$route.params.docType
    this.formUserInsModel.IdDocument = this.$route.params.docNum === undefined ? '' : this.$route.params.docNum
    this.formUserInsModel.IdCelPhone = this.$route.params.celNum === undefined ? '' : this.$route.params.celNum
    if (!(this.$route.params.mailRef === undefined)) {
      this.formUserInsModel.IdMail = this.$route.params.mailRef
      this.msnFilesAlert = '* El tamaño del archivo a cargar no debe excede el límite permitido de ' + IberoHelpers.formatBytes(this.$store.state.filesIbero.sizeFiles, 0) + '<br>* Las extenciones permitidas para la carga de documentos son: (' + this.$store.state.filesIbero.extFiles.replace(/[|]/g, ', ') + ')'
      this.processUser()
      debugger
    } else {
      this.formUserInsModel.IdMail = ''
    }
  },
}
</script>